import { useQuery } from "@tanstack/react-query";
import referralCodeService from "..";

const useUserSignupByReferralCode = () =>
  useQuery({
    queryKey: ["get-referral-list"],
    queryFn: () => referralCodeService.getUserSignupByReferralCode(),
    select: (res) => res,
  });

export { useUserSignupByReferralCode };
